import { useQuery } from '@tanstack/react-query'
import { getFarmProjectArea } from '@/services/farmMapping/getFarms'
import { ProgramConfig } from '@/types/apiModels'
import { isProjectAreaEnabled } from '@/utils/programConfig/areaSubtractions'
import { queryKeys } from './queryKeys'

type UseProjectAreaParams = {
  farmId: string
  programConfig: ProgramConfig | null | undefined
}

type UseProjectAreaResult = {
  projectAreaGeometry: GeoJSON.Feature | null
  hasProjectArea: boolean
  isLoading: boolean
}

export const useProjectArea = ({
  farmId,
  programConfig,
}: UseProjectAreaParams): UseProjectAreaResult => {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.projectArea(farmId),
    queryFn: ({ signal }) => getFarmProjectArea({ farmId, signal }),
    enabled: isProjectAreaEnabled(programConfig) && !!farmId,
  })

  return {
    projectAreaGeometry: data ?? null,
    hasProjectArea: data?.geometry != null,
    isLoading,
  }
}
